var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.time)?_c('div',{staticClass:"countdown-wrapper"},[_vm._v("\n  "+_vm._s(_vm.time)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }